import { httpDelete, httpGet, httpPost, httpPut } from "@/request/http";

const path = "/ip-allow-lists";

export default {
  getAll() {
    return httpGet(path);
  },
  create(item) {
    return httpPost(path, item, { meta: { preserveEmptyStrings: true } });
  },
  update(id, item) {
    return httpPut(`${path}/${id}`, item, {
      meta: { preserveEmptyStrings: true },
    });
  },
  remove(id) {
    return httpDelete(`${path}/${id}`);
  },
};
